import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import AddCardIcon from "@mui/icons-material/AddCard";
import AddLocationIcon from "@mui/icons-material/AddLocation";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import DirectionsBikeIcon from "@mui/icons-material/DirectionsBike";
import DiscountIcon from "@mui/icons-material/Discount";
import ElectricBikeIcon from "@mui/icons-material/ElectricBike";
import FitbitIcon from "@mui/icons-material/Fitbit";
import FormatColorTextIcon from "@mui/icons-material/FormatColorText";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import StoreIcon from "@mui/icons-material/Store";
import TextDecreaseIcon from "@mui/icons-material/TextDecrease";
import TextIncreaseIcon from "@mui/icons-material/TextIncrease";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import EventSeatIcon from "@mui/icons-material/EventSeat";
import MenuIcon from "@mui/icons-material/Menu";
import TuneIcon from "@mui/icons-material/Tune";
import Button from "components/common/Button";
import api from "config/api";
import { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import { TIME_ZONES } from "utils/constants";
import Select from "components/common/Select";
import { MenuItem, Switch } from "@mui/material";
type Props = {};

const inventoryItems: any = {
  OnlineOrderingStatus: {
    type: "boolean",
    label: "Don't Allow online ordering",
    Icon: PeopleAltIcon,
    // className: "lg:col-span-2",
    description:
      "Don't allow user to place order from the site, if OFF user can't access the site",
  },
  timeZone: {
    type: "select",
    label: "Time zone",
    Icon: PeopleAltIcon,
    // className: "lg:col-span-2",
    description: "Time zone that will be used in the site",
    options: Object.keys(TIME_ZONES),
  },
  ClosePickupOrder: {
    type: "boolean",
    label: "Close pickup order",
    Icon: StoreIcon,
    description: "Close pick up type order from store",
  },
  CloseDeliveryOrder: {
    type: "boolean",
    label: "Close delivery order",
    Icon: DeliveryDiningIcon,
    description: "Close delivery type order from store",
  },
  PickupOnlinePayment: {
    type: "boolean",
    label: "Allow online payment in pickup",
    Icon: AddBusinessIcon,
    description: "Allow user to make online payment when order type is pick up",
  },
  DeliveryOnlineOrder: {
    type: "boolean",
    label: "Allow online payment in delivery",
    Icon: AddCardIcon,
    description:
      "Allow user to make online payment when order type is delivery",
  },
  DontPayAtStorePickup: {
    type: "boolean",
    label: "Don't allow pay at store in pickup",
    Icon: ShoppingCartIcon,
    description:
      "Don't allow user to pay at count / store when order type is pick up",
  },
  DontPayAtStoreDelivery: {
    type: "boolean",
    label: "Don't allow pay at store in delivery",
    Icon: ShoppingCartCheckoutIcon,
    description:
      "Don't allow user to pay at count / store when order type is deliver",
  },
  ShowCompanyName: {
    type: "boolean",
    label: "Show company name",
    Icon: FormatColorTextIcon,
    description: "Show company name on the user website",
  },
  showLogo: {
    type: "boolean",
    label: "Show App Logo",
    Icon: FitbitIcon,
    description: "Show app logo name on the user website",
  },
  ApplyTakeOutDeliveryPrice: {
    type: "boolean",
    label: "Apply takeout delivery price",
    Icon: DirectionsBikeIcon,
    description: "Should apply extra charges for delivery and takeout",
  },
  ApplyDeliveryChargesAsKm: {
    type: "boolean",
    label: "Apply delivery charges as KM",
    Icon: ElectricBikeIcon,
    description: "Apply delivery changes to user as KM",
  },

  MinimumDeliveryOrder: {
    type: "boolean",
    label: "Minimum delivery order",
    Icon: TextDecreaseIcon,
    description: "Check minimum amount on order with type delivery",
  },
  OnlineDeliveryBoundry: {
    type: "boolean",
    label: "Online delivery boundary",
    Icon: TextIncreaseIcon,
    description: "Check maximum amount on online delivery",
  },
  AllowDiscountOnDelivery: {
    type: "boolean",
    label: "Allow discount on delivery",
    Icon: LocalOfferIcon,
    description: "Allow discounts on order type delivery",
  },
  AllowDiscountOnPickup: {
    type: "boolean",
    label: "Allow discount on pickup",
    Icon: LocalOfferIcon,
    description: "Allow discounts on order type pickup",
  },
  OnlineSpecialDiscount: {
    type: "number",
    label: "Online special discount",
    Icon: DiscountIcon,
    description: "Allow special discounts on the website",
  },
  DontDisplayTipOption: {
    type: "boolean",
    label: "Don't display tip options",
    Icon: TipsAndUpdatesIcon,
    description: "Tips should not be shown in user panel",
  },
  DisplayLocationOnCheckout: {
    type: "boolean",
    label: "Display location on checkout",
    Icon: AddLocationIcon,
    description:
      "Display the delivery location while checkout in delivery orders",
  },
  menuDirection: {
    type: "direction",
    label: "Menu Position",
    Icon: MenuIcon,
    description: "Set menu position to 'Top' or 'Left'",
    options: ["Top", "Left"],
  },
  DeptDisplayOption: {
    type: "select",
    label: "Department Display Option",
    Icon: MenuIcon,
    description: "Show details of the department",
    options: ["Text", "Image", "Both"],
  },
  CloseReservationOrder: {
    type: "boolean",
    label: "Reservation Order Options",
    Icon: EventSeatIcon,
    description: "Show reservation order option for users",
  },
  clearCartOnBrowerExit: {
    type: "boolean",
    label: "Clear cart on browser exit",
    Icon: ProductionQuantityLimitsIcon,
    // className: "lg:col-span-2",
    description:
      "Don't clear cart, if OFF user can't access the site clear cart on browser exit",
  },
};

const OptionItem = ({
  Icon,
  label,
  description,
  isSelected,
  onToggle,
  type,
  className = "",
  options = [],
  currentTime = "",
}: any) => (
  <div
    className={`group flex min-h-[104px] flex-col gap-4 rounded-xl border border-gray-200 bg-white p-4 shadow-sm transition hover:-translate-y-0.5 hover:border-gray-300 hover:shadow-md sm:flex-row sm:items-center sm:justify-between ${className}`}
  >
    <div className="flex min-w-0 items-start gap-3">
      <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-gray-100 text-gray-700 transition group-hover:bg-primary/10 group-hover:text-primary">
        <Icon className="!text-[28px]" />
      </span>
      <div className="min-w-0">
        <h4 className="text-sm font-semibold text-gray-950">{label}</h4>
        <p className="mt-1 text-xs leading-5 text-gray-500">{description}</p>
        {currentTime && (
          <div className="mt-2 inline-flex rounded-full bg-gray-100 px-2.5 py-1 text-xs font-bold text-gray-700 ring-1 ring-gray-200">
            {currentTime}
          </div>
        )}
      </div>
    </div>

    <div className="flex shrink-0 justify-end sm:min-w-[132px]">
    {type === "number" ? (
      <input
        className="h-10 w-20 rounded-lg border border-gray-200 bg-gray-50 px-3 text-right text-sm font-semibold text-gray-900 outline-none transition focus:border-primary focus:bg-white"
        type="number"
        max="100"
        value={isSelected}
        onChange={(e) =>
          onToggle(+e.target.value <= 100 ? e.target.value : 100)
        }
      />
    ) : type === "direction" && options.length >= 2 ? (
      <div className="flex overflow-hidden rounded-lg bg-gray-100 p-1">
        {options.map((option: string, index: number) => (
          <button
            type="button"
            key={option}
            onClick={() => onToggle(option)}
            className={`min-w-[58px] rounded-md px-3 py-2 text-center text-xs font-semibold transition ${
              isSelected === option
                ? "bg-primary text-themeSelColor shadow-sm"
                : "text-gray-600 hover:text-gray-950"
            }`}
          >
            {option}
          </button>
        ))}
      </div>
    ) : type === "select" ? (
      <>
        {isSelected && (
          <div className="w-full min-w-[160px] max-w-[220px]">
            <Select
              size="small"
              value={isSelected}
              onValueChange={(value) => onToggle(value)}
            >
              {options.map((item: string) => (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          </div>
        )}
      </>
    ) : (
      <div className="flex items-center gap-2">
        <span
          className={`text-xs font-semibold ${
            isSelected ? "text-green-700" : "text-gray-500"
          }`}
        >
          {isSelected ? "ON" : "OFF"}
        </span>
        <Switch
          checked={!!isSelected}
          onChange={() => onToggle(+!isSelected)}
          color="success"
        />
      </div>
    )}
    </div>
  </div>
);

const ProjectSetting = (props: Props) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>({});
  const [clockDate, setClockDate] = useState(() => new Date());

  const options = useMemo(() => Object.entries(inventoryItems), []);
  const enabledSettings = options.filter(
    ([title, item]: any) => item.type === "boolean" && data?.[title]?.Value
  ).length;
  const booleanSettings = options.filter(
    ([, item]: any) => item.type === "boolean"
  ).length;

  useEffect(() => {
    const timer = window.setInterval(() => setClockDate(new Date()), 1000);
    return () => window.clearInterval(timer);
  }, []);

  const getTimeZoneClock = (timeZoneName: string) => {
    const ianaTimeZone = TIME_ZONES[timeZoneName];
    if (!ianaTimeZone) return "";

    try {
      return new Intl.DateTimeFormat("en-US", {
        timeZone: ianaTimeZone,
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      }).format(clockDate);
    } catch {
      return "";
    }
  };

  useEffect(() => {
    api
      .get("/api/Option/GetSettings")
      .then(({ data }) => {
        setData({
          timeZone: {
            Id: 0,
            Value: inventoryItems.timeZone.options[0],
            Name: "timezone",
          },
          CloseReservationOrder: {
            Id: 0,
            Value: 0,
            Name: "CloseReservationOrder",
          },
          ...Object.entries(data).reduce(
            (e: any, [Name, Value]: any) => ({
              ...e,
              [Name]: { Id: 0, Value: isNaN(+Value) ? Value : +Value, Name },
            }),
            {}
          ),
        });
      })
      .catch((e) => {
        setData(
          Object.keys(inventoryItems).reduce(
            (e: any, Name) => ({ ...e, [Name]: { Id: 0, Value: 0, Name } }),
            {}
          )
        );
      });
  }, []);

  const updateValue = (key: keyof typeof inventoryItems, value: any) => {
    setData((e: any) => {
      const obj = structuredClone(e);

      obj[key].Value = value;
      return obj;
    });
  };

  const handelSubmit = () => {
    if (data.ClosePickupOrder.Value && data.CloseDeliveryOrder.Value) {
      toast.error("Pickup and delivery both can't be closed");
      return;
    }

    if (!data.PickupOnlinePayment.Value && data.DontPayAtStorePickup.Value) {
      toast.error(
        "pay at store and online payment both can't be disabled for pickup"
      );
      return;
    }
    if (!data.DeliveryOnlineOrder.Value && data.DontPayAtStoreDelivery.Value) {
      toast.error(
        "pay at store and online payment both can't be disabled for delivery"
      );
      return;
    }

    setLoading(true);
    api
      .post("/api/Option/AddUpdateSettings", Object.values(data))
      .then((res) => {
        toast.success("Settings updated successfully");
      })
      .catch((e) => {
        toast.error("Something went wrong");
      })
      .finally(() => setLoading(false));
  };
  return (
    <div className="w-full p-4">
      <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
        <div className="flex flex-col gap-4 border-b border-gray-100 px-5 py-4 lg:flex-row lg:items-center lg:justify-between">
          <div className="flex items-center gap-3">
            <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary text-themeSelColor">
              <TuneIcon className="!text-[24px]" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900">
                Project Setting
              </h3>
              <p className="text-sm text-gray-500">
                {enabledSettings} of {booleanSettings} switches enabled
              </p>
            </div>
          </div>

          <Button disabled={loading} onClick={handelSubmit}>
            Save Settings
          </Button>
        </div>

        <div className="grid max-h-[calc(100vh-174px)] w-full grid-cols-1 gap-3 overflow-y-auto bg-gray-50 p-4 xl:grid-cols-2">
          {options.map(([title, item]: any) => (
            <OptionItem
              key={title}
              {...item}
              {...(inventoryItems?.[title] || {})}
              isSelected={data?.[title]?.Value}
              currentTime={
                title === "timeZone"
                  ? getTimeZoneClock(data?.[title]?.Value)
                  : ""
              }
              onToggle={(v: any) => updateValue(title, v)}
            />
          ))}
        </div>

        <div className="flex justify-end border-t border-gray-100 bg-white px-5 py-3">
          <Button disabled={loading} onClick={handelSubmit}>
            Save Settings
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProjectSetting;
